module.exports = __webpack_public_path__ + "media/components/common/images/IconChevronRight-28b5170439b30d1dac80c3c7f18ddfe2.svg";